export default "/assets/webpack-assets/GT-Walsheim-Pro-Bold.8088980ac23ecb958bdd4f142c4f2d8b.woff";